import { Modal, Text, Button, Group } from "@mantine/core";

type Props = {
  opened: boolean;
  onExtend: () => void;
  onDismiss: () => void;
};

export default function PaymentWindowExtendModal({ opened, onExtend, onDismiss }: Props) {
  return (
    <Modal opened={opened} onClose={onDismiss} title="Payment reminder" centered>
      <Text size="sm" mb="md">
        There are only 12 hours remaining to complete payment. You can extend the time shown here by 48 hours.
      </Text>
      <Group justify="flex-end" gap="sm">
        <Button variant="default" onClick={onDismiss}>
          Not now
        </Button>
        <Button onClick={onExtend}>Extend 48 hours</Button>
      </Group>
    </Modal>
  );
}
